<template>
  <div class="ListingPagination md:border-t md:pt-8 mt-4">
    <div class="ListingGrid-loading text-primary flex justify-center" v-show="loading">
      <img src="@/images/icons/bouncing-ball.svg" class="h-48" />
    </div>

    <div class="text-center mt-24 text-sm" v-if="!loading && listings.length == 0">
      Sorry we could not find any artworks based on your search.
    </div>

    <div :class="{ 'view-list': isList }" class="ListingGrid" ref="grid" :key="viewKey">
      <div class="ListingCol" v-for="(chunk, index) in listingsChunks" :key="index">
        <ListingItem v-for="listing in chunk" :listing="listing" :key="listing.id" :class="$style.listingitem" :price-filter-applied="priceFilterApplied" :size-filter-applied="sizeFilterApplied" />
      </div>
    </div>

    <div data-turbo="false" v-if="listings_count > perPage">
      <PaginationWithDefaults v-model="page" :page-count="pageCount" />
    </div>
  </div>
</template>

<script setup>
import PaginationWithDefaults from "@/components/PaginationWIthDefaults.vue"
import ListingItem from "@/components/Listing/Item.vue"
</script>

<script>
import { mapState, mapActions } from "vuex"
import isMobile from "is-mobile"

export default {
  name: "ListingPagination",
  props: ["chunck", "perPage", "priceFilterApplied", "sizeFilterApplied"],
  data() {
    return {
      col: null,
    }
  },
  methods: {
    paginate(page) {
      const that = this

      this.changePage({ page })
      window.history.pushState({ page: page, turbo: {} }, "", `${window.location.pathname}?page=${page}`)
      this.$emit("paginate", page)

      window.onpopstate = function () {
        const page = event.state.page || 1
        that.changePage({ page })
      }
    },
    ...mapActions("filter", ["changePage"]),
  },
  computed: {
    listingsChunks() {
      // speading listings in columns to make the grid look like masonry layout

      const columns = new Array(this.columnsNumber)

      for (let i = 0; i < columns.length; i++) {
        columns[i] = []
      }

      this.listings.forEach((listing, index) => {
        const currentColumn = index % this.columnsNumber
        columns[currentColumn].push(listing)
      })

      return columns
    },
    columnsNumber() {
      if (this.$mq == "lg") return 4
      if (isMobile({ featureDetect: true })) return 2

      return 3
    },
    isList() {
      return this.view == "list"
    },
    pageCount() {
      return Math.ceil(parseInt(this.listings_count) / parseInt(this.perPage))
    },
    page: {
      get() {
        return this.currentPage
      },
      set(page) {
        this.paginate(page)
      },
    },
    ...mapState("filter", ["listings", "loading", "view", "listings_count", "viewKey"]),
    ...mapState("filter", {
      currentPage: (state) => parseInt(state.filters.page),
    }),
  },
}
</script>

<style lang="scss" scoped>
@use "~@/css/utils/media";

.ListingGrid {
  @apply justify-between;
  display: flex;
  flex-wrap: wrap;

  .ListingCol,
  & > .Listing_Item {
    width: calc(50% - 10px);

    @screen md {
      width: calc(33% - 10px);
    }

    @screen lg {
      width: calc(25% - 20px);
    }
  }

  @include media.screen-sm-down {
    &.view-list {
      display: block;

      .ListingCol {
        width: 100%;
        &:nth-child(n + 2) {
          display: none;
        }
      }
    }
  }

  @screen md {
    min-height: 450px;
    grid-template: auto / repeat(3, 1fr);
  }

  @screen lg {
    grid-template: auto / repeat(4, 1fr);
    column-gap: 20px;
    row-gap: 30px;
  }

  &-loading {
    margin-top: 150px;
    min-height: 500px;
    font-size: 15rem;
    position: sticky;
    top: 250px;
    bottom: 250px;
  }
}
</style>

<style module>
.listingitem {
  @apply mb-8;
}
</style>
